import { validateUrlLink } from '../../../utils';
import { CustomStorageFieldTypes, DataStorageFormValues, UserStorageTypes } from './settings';

export const UserDataStorageValidator = (values: DataStorageFormValues): DataStorageFormValues => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const errors: DataStorageFormValues = {};

  Object.keys(CustomStorageFieldTypes).forEach((customName: CustomStorageFieldTypes) => {
    if (values[customName] && !validateUrlLink(values[customName] as string)) {
      errors[customName] = 'app.validation.url-invalid';
    }

    if (values.users_storage === UserStorageTypes.playfab && !values.playfab_title_id?.trim()) {
      errors.playfab_title_id = 'app.validation.required';
    }

    if (values.users_storage === UserStorageTypes.firebase && !values.firebase_apikey?.trim()) {
      errors.firebase_apikey = 'app.validation.required';
    }
  });

  return errors;
};
